import React from 'react';
import { Globe } from '../../common/icons';

const NavbarGoogleTranslate = (props) => {
  const { gold} = props;
  const globeIconClassName = gold ? 'navbar-google-translate-icon-gold' : '';

  return (
    <div className='navbar-google-translate-container'>
      <Globe className={globeIconClassName} />
      <div id="google-translate" />
    </div>
  );
};


export default NavbarGoogleTranslate;



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/navbar-google-translate.jsx